export var actionTypePrefix = '@@POLLS';
//# sourceMappingURL=constants.js.map